import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { FaTools } from "react-icons/fa";

const ToolMaintenancePage = () => {
  return (
    <Box minH="100vh" bg="white">
      {/* Hero Section */}
      <Box
        bg="white"
        py={{ base: 16, md: 24 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Heading
          as="h1"
          fontSize={{ base: "4xl", md: "6xl" }}
          fontWeight="800"
          color="gray.900"
          mb={6}
          fontFamily="'Work Sans', sans-serif"
        >
          How to Maintain Your Tools
        </Heading>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.600"
          maxW="2xl"
          mx="auto"
        >
          Proper maintenance of your tools can extend their lifespan and ensure
          optimal performance. Follow these steps to keep your tools in top
          condition and ready for any job!
        </Text>
      </Box>

      {/* Content Section */}
      <Box bg="gray.50" py={{ base: 12, md: 20 }} px={{ base: 6, md: 12 }}>
        <Box maxW="1200px" mx="auto">
          {/* Tools & Materials Section */}
          <Box
            mb={12}
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            p={8}
            boxShadow="sm"
          >
            <Heading
              as="h2"
              fontSize="2xl"
              fontWeight="700"
              color="gray.900"
              mb={4}
            >
              Tools & Materials You'll Need
            </Heading>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={FaTools} color="orange.500" />
                Cleaning Supplies (cloth, brushes, etc.)
              </ListItem>
              <ListItem>
                <ListIcon as={FaTools} color="orange.500" />
                Lubricants (oil or grease)
              </ListItem>
              <ListItem>
                <ListIcon as={FaTools} color="orange.500" />
                Wrenches and Screwdrivers
              </ListItem>
              <ListItem>
                <ListIcon as={FaTools} color="orange.500" />
                Storage Containers
              </ListItem>
            </List>
          </Box>

          {/* Step-by-Step Instructions */}
          <VStack align="start" spacing={8}>
            {/* Step 1 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Step 1: Clean Your Tools
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Use a cloth or brush to remove dirt, dust, and debris from your
                tools. Make sure to clean the crevices and any moving parts.
              </Text>
            </Box>

            {/* Step 2 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Step 2: Inspect for Damage
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Check for any signs of wear or damage on your tools. Look for
                rust, cracks, or loose parts that may need repair or
                replacement.
              </Text>
            </Box>

            {/* Step 3 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Step 3: Lubricate Moving Parts
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Apply lubricant to any moving parts of your tools to prevent
                rust and ensure smooth operation. Follow the manufacturer's
                recommendations for specific lubrication guidelines.
              </Text>
            </Box>

            {/* Step 4 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Step 4: Store Properly
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Keep your tools organized in a dry, cool place. Use storage
                containers or racks to prevent damage and ensure easy access.
              </Text>
            </Box>

            {/* Final Tip */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Text
                fontSize={{ base: "lg", md: "xl" }}
                fontWeight="700"
                color="gray.900"
              >
                Well done! Regular maintenance will keep your tools functioning
                effectively for years to come. Remember to check them frequently
                and perform maintenance as needed.
              </Text>
            </Box>
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export default ToolMaintenancePage;
